module.exports = __webpack_public_path__ + "img/haikei_maisy.42bb88a6.jpg";